import { render, staticRenderFns } from "./InsideList.vue?vue&type=template&id=37f55b0a&scoped=true"
import script from "./InsideList.vue?vue&type=script&lang=js"
export * from "./InsideList.vue?vue&type=script&lang=js"
import style0 from "./InsideList.vue?vue&type=style&index=0&id=37f55b0a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f55b0a",
  null
  
)

export default component.exports